export const SET_TIME = "SET_TIME";



// WEBPACK FOOTER //
// ./src/store/actions/time.js